import type { ConfigRequest } from '@pba/react-utils';
import type { paths } from '@pba/types-openapi-node';
import { type ApiClientResponse, nodeApiClient, nodeApiRoutes } from 'common/services';
import type { PaginatedDataObjects } from 'models/service';
import type { NodeTodoDataObject } from '../types/service';

type NodeTodoRequestParams = paths['/todos']['get']['parameters']['query'];

export const getNodeTodos = async ({ config }: ConfigRequest<NodeTodoRequestParams>) =>
  nodeApiClient.get<
    PaginatedDataObjects<NodeTodoDataObject>,
    ApiClientResponse<PaginatedDataObjects<NodeTodoDataObject>>
  >(nodeApiRoutes.todos.get, config);
